import moment from 'moment';
import { MovementsType, SearchType, TransactionsType } from 'v2/interfaces/financial';

export const TransactionTypesFilter = [
  {
    label: 'Todos',
    value: TransactionsType.ALL,
    type: [MovementsType.ENTRY, MovementsType.OUT],
  },
  {
    label: 'Cobranças Produtos/Serviços',
    value: TransactionsType.BILLING,
    type: [MovementsType.OUT],
  },
  {
    label: 'Chargeback',
    value: TransactionsType.CHARGEBACK,
    type: [MovementsType.ENTRY, MovementsType.OUT],
  },
  {
    label: 'Estorno',
    value: TransactionsType.REVERSAL,
    type: [MovementsType.ENTRY],
  },
  {
    label: 'Ganhos',
    value: TransactionsType.EARNINGS,
    type: [MovementsType.ENTRY],
  },
  {
    label: 'Reembolso',
    value: TransactionsType.REFUND,
    type: [MovementsType.OUT],
  },
  {
    label: 'Tarifas',
    value: TransactionsType.FEES,
    type: [MovementsType.OUT],
  },
  {
    label: 'Transferências',
    value: TransactionsType.TRANSFERS,
    type: [MovementsType.OUT],
  },
  {
    label: 'Outros',
    value: TransactionsType.OTHERS,
    type: [MovementsType.ENTRY, MovementsType.OUT],
  },
];

export const MovementTypesFilter = [
  {
    label: 'Todos',
    value: MovementsType.ALL,
  },
  {
    label: 'Entrada',
    value: MovementsType.ENTRY,
  },
  {
    label: 'Saída',
    value: MovementsType.OUT,
  },
];

export const SearchTypeFilter = [
  {
    label: 'Todos',
    value: SearchType.ALL,
  },
  {
    label: 'Fatura',
    value: SearchType.INVOICE,
    placeholder: 'Informe o número da fatura',
  },
  {
    label: 'Produto',
    value: SearchType.PRODUCT,
    placeholder: 'Informe o ID do produto',
  },
  {
    label: 'E-mail do comprador',
    value: SearchType.EMAIL,
    placeholder: 'Informe o e-mail do comprador',
  },
  {
    label: 'Nome do comprador',
    value: SearchType.NAME,
    placeholder: 'Informe o nome do comprador',
  },
  {
    label: 'CPF/CNPJ do comprador',
    value: SearchType.DOCUMENT,
    placeholder: 'Informe o CPF/CNPJ do comprador',
  },
];

export const PresetRanges = [
  {
    value: '7',
    label: '7 dias',
  },
  {
    value: '15',
    label: '15 dias',
  },
  {
    value: '30',
    label: '30 dias',
  },
  {
    value: '60',
    label: '60 dias',
  },
  {
    value: '90',
    label: '90 dias',
  },
];

const today = moment();

export const calendarPreset = [
  {
    id: 'week',
    text: '7 dias',
    start: moment().subtract(6, 'days'),
    end: today,
  },
  {
    id: 'halfMonth',
    text: '15 dias',
    start: moment().subtract(14, 'days'),
    end: today,
  },
  {
    id: 'month',
    text: '30 dias',
    start: moment().subtract(29, 'days'),
    end: today,
  },
  {
    id: 'twoMonth',
    text: '60 dias',
    start: moment().subtract(59, 'days'),
    end: today,
  },
  {
    id: 'threeMonth',
    text: '90 dias',
    start: moment().subtract(89, 'days'),
    end: today,
  },
];
